import { useState, useEffect } from 'react';

interface IntroAnimationProps {
  onComplete: () => void;
  isMobile: boolean;
}

export default function IntroAnimation({ onComplete, isMobile }: IntroAnimationProps) {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isVisible, setIsVisible] = useState(true);

  const slides = [
    "Hereabout - a new kind of map."
  ];

  useEffect(() => {
    const displayDuration = 2500; // Show for 2.5 seconds
    const totalDuration = displayDuration + 800; // Add fade out time

    // Fade out after display duration
    const fadeOutTimer = setTimeout(() => {
      setIsVisible(false);

      // If this is the last slide, call onComplete immediately when fade starts
      if (currentSlide === slides.length - 1) {
        onComplete();
      }
    }, displayDuration);

    // Move to next slide after fade out completes
    const nextSlideTimer = setTimeout(() => {
      if (currentSlide < slides.length - 1) {
        setCurrentSlide(currentSlide + 1);
        setIsVisible(true);
      }
    }, totalDuration);

    return () => {
      clearTimeout(fadeOutTimer);
      clearTimeout(nextSlideTimer);
    };
  }, [currentSlide, onComplete, slides]);

  return (
    <div style={styles(isMobile).container}>
      <div
        style={{
          ...styles(isMobile).textContainer,
          opacity: isVisible ? 1 : 0,
        }}
      >
        <p style={styles(isMobile).text}>{slides[currentSlide]}</p>
      </div>
    </div>
  );
}

const styles = (isMobile: boolean) => ({
  container: {
    position: 'absolute' as const,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 100,
    borderRadius: '19.5%',
  },
  textContainer: {
    transition: 'opacity 0.8s ease-in-out',
    padding: '0 40px',
    maxWidth: isMobile ? '90%' : '80%',
  },
  text: {
    fontSize: isMobile ? '1.5rem' : 'clamp(1.6rem, 2.5vw, 2.5rem)',
    fontWeight: '700',
    lineHeight: '1.4',
    color: '#fc2c03',
    textAlign: 'center' as const,
    margin: 0,
    fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  },
});
